import Vue from 'vue'
import Router from 'vue-router'
import Login from '../view/Login'
//import Register from '../view/Register'
import Home from '../view/Home'
import Welcome from '../view/Welcome'
import shipCompanyDetails from '../view/shipCompany/details'

import ShopOrderListCardAdd from '../view/shipCompany/shopOrderCardAdd'
import ShopOrderListShopAdd from '../view/shipCompany/shopOrderShopAdd'

import shopInfoList from '../view/shipCompany/shopInfoList'
import ShopOrderDeal from '../view/shipCompany/shopOrderDeal'

import ShopRemind from '../view/shipCompany/shopRemind'
import ShopRemindList from '../view/shipCompany/shopRemindList'

import CarList from '../view/car/carList'
import CarForm from  '../view/car/carForm'
import extrasFeeAdd from  '../view/fee/extrasFeeAdd'
import extrasFeeEdit from  '../view/fee/extrasFeeEdit'
import DepositList from '../view/car/depositList'
import LeaveList from '../view/car/leaveList'
import ReplaceList from '../view/car/replaceList'
import SuspendList from '../view/car/suspendList'
import TransferList from '../view/car/transferList'

import BorrowList from '../view/borrow/borrowList'
import PayPlanList from '../view/borrow/payPlanList'
import PayList from '../view/borrow/payList'

import CmpUserList from '../view/sys/cmpUserList'
import EmployeeList from '../view/sys/employeeList'
import ModuleList from '../view/sys/moduleList'
import RoleList from '../view/sys/roleList'
import DepartmentList from '../view/sys/departmentList'
import LoanList from '../view/loan/loanList'
import InvestiList from '../view/loan/investiList'
import MoveList from '../view/loan/moveList'
import AttachmentList from '../view/loan/attachmentList'
import advanceList from '../view/loan/advanceList'
import PayInfoList from '../view/loan/PayList'

import insuranceAddByProduct from '../view/insurance/insuranceAddByProduct'
import InsuranceOrderList from '../view/insurance/insuranceOrderList'
import InsuranceTeamOrder from '../view/insurance/insuranceTeamOrder'
import insuranceSysTeamOrder from '../view/insurance/insuranceSysTeamOrder'
import insuranceAdd from '../view/insurance/insuranceAdd'
import signDocList from '../view/insurance/signDocList'
import insuranceSysCar from '../view/insurance/insuranceSysCar'
import insuranceSysProduct from '../view/insurance/insuranceSysProduct'
import payPublic from '../view/insurance/payPublic'



import FeeDictList from '../view/fee/feeDictList'
import manageFeeList from '../view/fee/manageFeeList'
import operationFeeList from '../view/fee/operationFeeList'
import drivingFeeList from '../view/fee/drivingFeeList'
import extrasFeeList from '../view/fee/extrasFeeList'
import twoLevelFeeList from '../view/fee/twoLevelFeeList'
import examination from '../view/fee/examination'
import occupationalList from '../view/fee/occupationalList'
//import assessorList from '../view/fee/assessorList'

import saftyList from '../view/remind/saftyList'
import insuranceList from '../view/remind/insuranceList'

import ManageList from '../view/remind/manageList'
import towLevelList from '../view/remind/towLevelList'
import practiceList from '../view/remind/practiceList'
import annuaDue from '../view/remind/annuaDue'
import tradingList from '../view/remind/tradingList'
import driveList from '../view/remind/driveList'
import gradeEstimation from '../view/remind/gradeEstimation'
import corpNameList from '../view/insurance/corpNameList'
import userInfo from '../view/user/userInfo'
import otherChannelList from '../view/shipCompany/otherChannelList'


Vue.use(Router)


var router = new Router({
  mode: 'history',  //去掉url中的#
  ignoreDuplicates: true,// 添加忽略重复导航的配置
  // base: '/',        // 当前线上根目录
    routes: [
      { path: '/login', name: 'Login', component: Login},
      //{ path: '/Register', name: 'Register', component: Register},
      { path: '/home',name: 'Home', component: Home, redirect: '/welcome',
        children:[
          {
            path: '/corpNameList',name: 'corpNameList',component: corpNameList
          },
          {
            path: '/welcome',name: 'Welcome',component: Welcome
          },
          {
            path: '/driveList',name: 'driveList',component: driveList
          },
          {
            path: '/annuaDue',name: 'annuaDue',component: annuaDue
          },
          {
            path: '/tradingList',name: 'tradingList',component: tradingList
          },
          {
            path: '/saftyList',name: 'saftyList',component: saftyList
          },
          {
            path: '/manageList',name: 'ManageList',component: ManageList
          },
          {
            path: '/towLevelList',name: 'towLevelList',component: towLevelList
          },
          {
            path: '/practiceList',name: 'practiceList',component: practiceList
          },
          {
            path: '/insuranceList',name: 'insuranceList',component: insuranceList
          },
          {
            path: '/gradeEstimation',name: 'gradeEstimation',component: gradeEstimation
          },
          {
            path: '/shipCompanyDetails',name: 'shipCompanyDetails',component: shipCompanyDetails
          },
          {
            path: '/shopOrderCardAdd',name: 'ShopOrderListCardAdd',component: ShopOrderListCardAdd
          },
          {
            path: '/shopOrderShopAdd',name: 'ShopOrderListShopAdd',component: ShopOrderListShopAdd
          },
          {
            path: '/shopInfoList',name: 'shopInfoList',component: shopInfoList
          },
          {
            path: '/otherChannelList',name: 'otherChannelList',component: otherChannelList
          },
          {
            path: '/shopOrderDeal',name: 'ShopOrderDeal',component: ShopOrderDeal
          },
          {
            path: '/shopRemind',name: 'ShopRemind',component: ShopRemind
          },
          {
            path: '/shopRemindList',name: 'ShopRemindList',component: ShopRemindList
          },
          {
            path: '/carList',name: 'CarList',component: CarList
          },
          {
            path: '/carForm',meta:{name:'车辆档案新增',text:'车辆建档',text1:'车辆档案'},name: 'CarForm',component: CarForm
          },
          {
            path: '/depositList',name: 'DepositList',component: DepositList
          },
          {
            path: '/leaveList',name: 'LeaveList',component: LeaveList
          },

          {
            path: '/replaceList',name: 'ReplaceList',component: ReplaceList
          },
          {
            path: '/suspendList',name: 'SuspendList',component: SuspendList
          },
          {
            path: '/transferList',name: 'TransferList',component: TransferList
          },

          {
            path: '/cmpUserList',name: 'CmpUserList',component: CmpUserList
          },
          {
            path: '/employeeList',name: 'EmployeeList',component: EmployeeList
          },
          {
            path: '/moduleList',name: 'ModuleList',component: ModuleList
          },
          {
            path: '/roleList',name: 'RoleList',component: RoleList
          },
          {
            path: '/departmentList',name: 'DepartmentList',component: DepartmentList
          },
          {
            path: '/loanList',name: 'LoanList',component: LoanList
          },
          {
            path: '/advanceList',name: 'advanceList',component: advanceList
          },
          {
            path: '/PayInfoList',name: 'PayInfoList',component: PayInfoList
          },
          {
            path: '/borrowList',name: 'BorrowList',component: BorrowList
          },
          {
            path: '/payPlanList',name: 'PayPlanList',component: PayPlanList
          },
          {
            path: '/payList',name: 'PayList',component: PayList
          },
          {
            path: '/investiList',name: 'InvestiList',component: InvestiList
          },
          {
            path: '/moveList',name: 'MoveList',component: MoveList
          },
          {
            path: '/attachmentList',name: 'AttachmentList',component: AttachmentList
          },
          {
            path: '/insuranceOrderList',name: 'InsuranceOrderList',component: InsuranceOrderList
          },
          {
            path: '/insuranceTeamOrder',name: 'InsuranceTeamOrder',component: InsuranceTeamOrder
          },
          {
            path: '/insuranceSysTeamOrder',name: 'insuranceSysTeamOrder',component: insuranceSysTeamOrder
          },
          {
            path: '/payPublic',name: 'payPublic',component: payPublic
          },
          {
            path: '/insuranceSysCar',name: 'insuranceSysCar',component: insuranceSysCar
          },
          {
            path: '/insuranceSysProduct',meta:{name:'系统单险种多车',text:'购买保险建档',text1:'保险管理'},name: 'insuranceSysProduct',component: insuranceSysProduct,

          },
          {
            path: '/insuranceAdd', meta:{name:'单车多险种',text:'购买保险建档',text1:'保险管理'},component: insuranceAdd,
          },
          {
            path: '/insuranceAddByProduct', meta:{name:'单险种多车',text:'购买保险建档',text1:'保险管理'},name: 'insuranceAddByProduct',component: insuranceAddByProduct
          },
          {
            path: '/signDocList',name: 'signDocList',component: signDocList
          },

          {
            path: '/manageFeeList',name: 'manageFeeList',component: manageFeeList
          },
          {
            path: '/operationFeeList',name: 'operationFeeList',component: operationFeeList
          },
          {
            path: '/feeDictList',name: 'FeeDictList',component: FeeDictList
          },
          {
            path: '/drivingFeeList',name: 'drivingFeeList',component: drivingFeeList
          },
          {
            path: '/extrasFeeList',name: 'extrasFeeList',component: extrasFeeList
          },
          {
            path: '/twoLevelFeeList',name: 'twoLevelFeeList',component: twoLevelFeeList
          },
          {
            path: '/examination',name: 'examination',component: examination
          },
          {
            path: '/occupationalList',name: 'occupationalList',component: occupationalList
          },
          {
            path: '/userInfo',name: 'userInfo',component: userInfo
          },
          {
            path: '/extrasFeeAdd',meta:{name:'费用列表新增',text:'费用列表',text1:'费用管理'},name: 'extrasFeeAdd',component: extrasFeeAdd
          },
          {
            path: '/extrasFeeEdit',meta:{name:'费用列表编辑',text:'费用列表',text1:'费用管理'},name: 'extrasFeeEdit',component: extrasFeeEdit
          },
        ]
      }
    ]
  })

//挂载路由导航守卫
router.beforeEach((to, from, next) => {
  if(to.path === '/login' ||  to.path === '/register') return next();
  //获取token
  const tokenStr = window.sessionStorage.getItem('token');
  //to.query
  let userData = '';
  if(to.query && to.query.data)
     userData = to.query.data;

  let redirectD = '';
  let uD = '';
  if(userData)
  {
    redirectD = to.path;
    uD = userData;
  }
  console.log("测试：",redirectD+'---'+uD);
  if(!tokenStr)
  {
    if(redirectD && uD)
       return next({
      path: '/login',
      query: { redirect: redirectD ,userData:uD} // 将要跳转路由的path作为参数，传递到登录页面
    })
    else
      return next('/login')
  }
  next()
})

export default router





// WEBPACK FOOTER //
// ./src/router/index.js